import { Box, Stack, Typography, Skeleton } from "@mui/material";

const RecentContentSkeleton = ({ label }) => {
  // Generate 6 skeleton content tiles
  const skeletonTiles = Array.from({ length: 6 }, (_, index) => index);

  return (
    <Box>
      <Typography fontSize={12} mb={1}>
        {label}:
      </Typography>
      <Stack direction="row" gap={1} sx={{ flexWrap: "wrap" }}>
        {skeletonTiles.map((index) => (
          <Box
            key={index}
            sx={{
              position: "relative",
              width: 139,
              height: 139,
              borderRadius: "4px",
              overflow: "hidden",
            }}
          >
            {/* Main image skeleton */}
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              sx={{ borderRadius: "4px" }}
            />

            {/* Top right badge skeleton */}
            <Box
              sx={{
                position: "absolute",
                top: "8px",
                right: "8px",
              }}
            >
              <Skeleton
                variant="rectangular"
                width={60}
                height={16}
                sx={{ borderRadius: "4px" }}
              />
            </Box>

            {/* Bottom content skeleton */}
            <Box
              sx={{
                position: "absolute",
                bottom: "8px",
                left: "8px",
              }}
            >
              <Stack gap={0.5}>
                <Skeleton
                  variant="text"
                  width={50}
                  height={16}
                  sx={{ bgcolor: "rgba(255, 255, 255, 0.3)" }}
                />
                <Skeleton
                  variant="text"
                  width={40}
                  height={16}
                  sx={{ bgcolor: "rgba(255, 255, 255, 0.3)" }}
                />
              </Stack>
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default RecentContentSkeleton;
